var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "110px",
    height: "100px",
    viewBox: "0 0 110 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 119 119 119 119 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-4---Inbox",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.3--Create-request---search",
    transform: "translate(-703.000000, -288.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(149.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(549.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stamp-document",
    transform: "translate(0.000000, 5.000000)",
    fill: "#F4F6FC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115,55.2212389 C115,24.7239292 90.375125,0 60,0 C29.624875,0 5,24.7239292 5,55.2212389 C5,63.3470442 6.76275,71.0545487 9.9005,78 L110.0995,78 C113.23725,71.0545487 115,63.3470442 115,55.2212389",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "programmer-male"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108,61.4336283 C108,35.2372212 86.7330625,14 60.5,14 C34.2669375,14 13,35.2372212 13,61.4336283 C13,68.4123009 14.522375,75.0328496 17.23225,81 L103.76775,81 C106.478812,75.0328496 108,68.4123009 108,61.4336283",
    id: "Fill-1",
    fill: "#F0F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,82 L106,82",
    id: "Stroke-3",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,82 L11,82",
    id: "Stroke-5",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,82 L111,82",
    id: "Stroke-7",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "77 78 98 78 98 38 77 38"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-11",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "77 78 98 78 98 38 77 38"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "77 37 98 37 98 35 77 35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-13",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "77 37 98 37 98 35 77 35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,82 L77,82 L77,35.2 C77,34.5376 76.552,34 76,34 C75.447,34 75,34.5376 75,35.2 L75,82 Z",
    id: "Fill-14",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,82 L77,82 L77,35.2 C77,34.5376 76.552,34 76,34 C75.447,34 75,34.5376 75,35.2 L75,82 Z",
    id: "Stroke-15",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,82 L101,82 L101,35.2 C101,34.5376 100.552,34 100,34 C99.447,34 99,34.5376 99,35.2 L99,82 Z",
    id: "Fill-16",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,82 L101,82 L101,35.2 C101,34.5376 100.552,34 100,34 C99.447,34 99,34.5376 99,35.2 L99,82 Z",
    id: "Stroke-17",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "52 78 73 78 73 38 52 38"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-19",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "52 78 73 78 73 38 52 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,44 L54,44 L54,41.3333333 C54,40.5973333 54.5297778,40 55.1851852,40 L68.8148148,40 C69.469037,40 70,40.5973333 70,41.3333333 L70,44 Z",
    id: "Fill-20",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,44 L54,44 L54,41.3333333 C54,40.5973333 54.5297778,40 55.1851852,40 L68.8148148,40 C69.469037,40 70,40.5973333 70,41.3333333 L70,44 Z",
    id: "Stroke-21",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,40 L60,44 L71,44 L71,41.3333333 C71,40.5973333 70.4524444,40 69.7777778,40 L63.6666667,40 Z",
    id: "Fill-22",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,40 L60,44 L71,44 L71,41.3333333 C71,40.5973333 70.4524444,40 69.7777778,40 L63.6666667,40 Z",
    id: "Stroke-23",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,63 L54,63 L54,60.3333333 C54,59.5973333 54.5297778,59 55.1851852,59 L68.8148148,59 C69.469037,59 70,59.5973333 70,60.3333333 L70,63 Z",
    id: "Fill-24",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,63 L54,63 L54,60.3333333 C54,59.5973333 54.5297778,59 55.1851852,59 L68.8148148,59 C69.469037,59 70,59.5973333 70,60.3333333 L70,63 Z",
    id: "Stroke-25",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,59 L60,63 L71,63 L71,60.3333333 C71,59.5973333 70.4524444,59 69.7777778,59 L63.6666667,59 Z",
    id: "Fill-26",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,59 L60,63 L71,63 L71,60.3333333 C71,59.5973333 70.4524444,59 69.7777778,59 L63.6666667,59 Z",
    id: "Stroke-27",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,45.6666667 C70,46.4026667 69.469037,47 68.8148148,47 L55.1851852,47 C54.5297778,47 54,46.4026667 54,45.6666667 L54,43 L70,43 L70,45.6666667 Z",
    id: "Fill-28",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,45.6666667 C70,46.4026667 69.469037,47 68.8148148,47 L55.1851852,47 C54.5297778,47 54,46.4026667 54,45.6666667 L54,43 L70,43 L70,45.6666667 Z",
    id: "Stroke-29",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,43 L60,47 L69.7777778,47 C70.4524444,47 71,46.4026667 71,45.6666667 L71,43 L63.6666667,43 Z",
    id: "Fill-30",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,43 L60,47 L69.7777778,47 C70.4524444,47 71,46.4026667 71,45.6666667 L71,43 L63.6666667,43 Z",
    id: "Stroke-31",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,44 L80,44 L80,41.3333333 C80,40.5973333 80.5297778,40 81.1851852,40 L94.8148148,40 C95.469037,40 96,40.5973333 96,41.3333333 L96,44 Z",
    id: "Fill-32",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,44 L80,44 L80,41.3333333 C80,40.5973333 80.5297778,40 81.1851852,40 L94.8148148,40 C95.469037,40 96,40.5973333 96,41.3333333 L96,44 Z",
    id: "Stroke-33",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,40 L85,44 L96,44 L96,41.3333333 C96,40.5973333 95.4524444,40 94.7777778,40 L88.6666667,40 Z",
    id: "Fill-34",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,40 L85,44 L96,44 L96,41.3333333 C96,40.5973333 95.4524444,40 94.7777778,40 L88.6666667,40 Z",
    id: "Stroke-35",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,45.6666667 C96,46.4026667 95.469037,47 94.8148148,47 L81.1851852,47 C80.5297778,47 80,46.4026667 80,45.6666667 L80,43 L96,43 L96,45.6666667 Z",
    id: "Fill-36",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,45.6666667 C96,46.4026667 95.469037,47 94.8148148,47 L81.1851852,47 C80.5297778,47 80,46.4026667 80,45.6666667 L80,43 L96,43 L96,45.6666667 Z",
    id: "Stroke-37",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,43 L85,47 L94.7777778,47 C95.4524444,47 96,46.4026667 96,45.6666667 L96,43 L88.6666667,43 Z",
    id: "Fill-38",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,43 L85,47 L94.7777778,47 C95.4524444,47 96,46.4026667 96,45.6666667 L96,43 L88.6666667,43 Z",
    id: "Stroke-39",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,53 L80,53 L80,50.3333333 C80,49.5973333 80.5297778,49 81.1851852,49 L94.8148148,49 C95.469037,49 96,49.5973333 96,50.3333333 L96,53 Z",
    id: "Fill-40",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,53 L80,53 L80,50.3333333 C80,49.5973333 80.5297778,49 81.1851852,49 L94.8148148,49 C95.469037,49 96,49.5973333 96,50.3333333 L96,53 Z",
    id: "Stroke-41",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,49 L85,53 L96,53 L96,50.3333333 C96,49.5973333 95.4524444,49 94.7777778,49 L88.6666667,49 Z",
    id: "Fill-42",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,49 L85,53 L96,53 L96,50.3333333 C96,49.5973333 95.4524444,49 94.7777778,49 L88.6666667,49 Z",
    id: "Stroke-43",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,55.6666667 C96,56.4026667 95.469037,57 94.8148148,57 L81.1851852,57 C80.5297778,57 80,56.4026667 80,55.6666667 L80,53 L96,53 L96,55.6666667 Z",
    id: "Fill-44",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,55.6666667 C96,56.4026667 95.469037,57 94.8148148,57 L81.1851852,57 C80.5297778,57 80,56.4026667 80,55.6666667 L80,53 L96,53 L96,55.6666667 Z",
    id: "Stroke-45",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,53 L85,57 L94.7777778,57 C95.4524444,57 96,56.4026667 96,55.6666667 L96,53 L88.6666667,53 Z",
    id: "Fill-46",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,53 L85,57 L94.7777778,57 C95.4524444,57 96,56.4026667 96,55.6666667 L96,53 L88.6666667,53 Z",
    id: "Stroke-47",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,72 L54,72 L54,69.3333333 C54,68.5973333 54.5297778,68 55.1851852,68 L68.8148148,68 C69.469037,68 70,68.5973333 70,69.3333333 L70,72 Z",
    id: "Fill-48",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,72 L54,72 L54,69.3333333 C54,68.5973333 54.5297778,68 55.1851852,68 L68.8148148,68 C69.469037,68 70,68.5973333 70,69.3333333 L70,72 Z",
    id: "Stroke-49",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,68 L60,72 L71,72 L71,69.3333333 C71,68.5973333 70.4524444,68 69.7777778,68 L63.6666667,68 Z",
    id: "Fill-50",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,68 L60,72 L71,72 L71,69.3333333 C71,68.5973333 70.4524444,68 69.7777778,68 L63.6666667,68 Z",
    id: "Stroke-51",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,74.6666667 C70,75.4026667 69.469037,76 68.8148148,76 L55.1851852,76 C54.5297778,76 54,75.4026667 54,74.6666667 L54,72 L70,72 L70,74.6666667 Z",
    id: "Fill-52",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,74.6666667 C70,75.4026667 69.469037,76 68.8148148,76 L55.1851852,76 C54.5297778,76 54,75.4026667 54,74.6666667 L54,72 L70,72 L70,74.6666667 Z",
    id: "Stroke-53",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,72 L60,76 L69.7777778,76 C70.4524444,76 71,75.4026667 71,74.6666667 L71,72 L63.6666667,72 Z",
    id: "Fill-54",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,72 L60,76 L69.7777778,76 C70.4524444,76 71,75.4026667 71,74.6666667 L71,72 L63.6666667,72 Z",
    id: "Stroke-55",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,53 L54,53 L54,50.3333333 C54,49.5973333 54.5297778,49 55.1851852,49 L68.8148148,49 C69.469037,49 70,49.5973333 70,50.3333333 L70,53 Z",
    id: "Fill-56",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,53 L54,53 L54,50.3333333 C54,49.5973333 54.5297778,49 55.1851852,49 L68.8148148,49 C69.469037,49 70,49.5973333 70,50.3333333 L70,53 Z",
    id: "Stroke-57",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,49 L60,53 L71,53 L71,50.3333333 C71,49.5973333 70.4524444,49 69.7777778,49 L63.6666667,49 Z",
    id: "Fill-58",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,49 L60,53 L71,53 L71,50.3333333 C71,49.5973333 70.4524444,49 69.7777778,49 L63.6666667,49 Z",
    id: "Stroke-59",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,55.6666667 C70,56.4026667 69.469037,57 68.8148148,57 L55.1851852,57 C54.5297778,57 54,56.4026667 54,55.6666667 L54,53 L70,53 L70,55.6666667 Z",
    id: "Fill-60",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,55.6666667 C70,56.4026667 69.469037,57 68.8148148,57 L55.1851852,57 C54.5297778,57 54,56.4026667 54,55.6666667 L54,53 L70,53 L70,55.6666667 Z",
    id: "Stroke-61",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,53 L60,57 L69.7777778,57 C70.4524444,57 71,56.4026667 71,55.6666667 L71,53 L63.6666667,53 Z",
    id: "Fill-62",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,53 L60,57 L69.7777778,57 C70.4524444,57 71,56.4026667 71,55.6666667 L71,53 L63.6666667,53 Z",
    id: "Stroke-63",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,63 L80,63 L80,60.3333333 C80,59.5973333 80.5297778,59 81.1851852,59 L94.8148148,59 C95.469037,59 96,59.5973333 96,60.3333333 L96,63 Z",
    id: "Fill-64",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,63 L80,63 L80,60.3333333 C80,59.5973333 80.5297778,59 81.1851852,59 L94.8148148,59 C95.469037,59 96,59.5973333 96,60.3333333 L96,63 Z",
    id: "Stroke-65",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,59 L85,63 L96,63 L96,60.3333333 C96,59.5973333 95.4524444,59 94.7777778,59 L88.6666667,59 Z",
    id: "Fill-66",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,59 L85,63 L96,63 L96,60.3333333 C96,59.5973333 95.4524444,59 94.7777778,59 L88.6666667,59 Z",
    id: "Stroke-67",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,64.6666667 C96,65.4026667 95.469037,66 94.8148148,66 L81.1851852,66 C80.5297778,66 80,65.4026667 80,64.6666667 L80,62 L96,62 L96,64.6666667 Z",
    id: "Fill-68",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,64.6666667 C96,65.4026667 95.469037,66 94.8148148,66 L81.1851852,66 C80.5297778,66 80,65.4026667 80,64.6666667 L80,62 L96,62 L96,64.6666667 Z",
    id: "Stroke-69",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,62 L85,66 L94.7777778,66 C95.4524444,66 96,65.4026667 96,64.6666667 L96,62 L88.6666667,62 Z",
    id: "Fill-70",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,62 L85,66 L94.7777778,66 C95.4524444,66 96,65.4026667 96,64.6666667 L96,62 L88.6666667,62 Z",
    id: "Stroke-71",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,72 L80,72 L80,69.3333333 C80,68.5973333 80.5297778,68 81.1851852,68 L94.8148148,68 C95.469037,68 96,68.5973333 96,69.3333333 L96,72 Z",
    id: "Fill-72",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,72 L80,72 L80,69.3333333 C80,68.5973333 80.5297778,68 81.1851852,68 L94.8148148,68 C95.469037,68 96,68.5973333 96,69.3333333 L96,72 Z",
    id: "Stroke-73",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,68 L85,72 L96,72 L96,69.3333333 C96,68.5973333 95.4524444,68 94.7777778,68 L88.6666667,68 Z",
    id: "Fill-74",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,68 L85,72 L96,72 L96,69.3333333 C96,68.5973333 95.4524444,68 94.7777778,68 L88.6666667,68 Z",
    id: "Stroke-75",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,74.6666667 C96,75.4026667 95.469037,76 94.8148148,76 L81.1851852,76 C80.5297778,76 80,75.4026667 80,74.6666667 L80,72 L96,72 L96,74.6666667 Z",
    id: "Fill-76",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,74.6666667 C96,75.4026667 95.469037,76 94.8148148,76 L81.1851852,76 C80.5297778,76 80,75.4026667 80,74.6666667 L80,72 L96,72 L96,74.6666667 Z",
    id: "Stroke-77",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,72 L85,76 L94.7777778,76 C95.4524444,76 96,75.4026667 96,74.6666667 L96,72 L88.6666667,72 Z",
    id: "Fill-78",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6666667,72 L85,76 L94.7777778,76 C95.4524444,76 96,75.4026667 96,74.6666667 L96,72 L88.6666667,72 Z",
    id: "Stroke-79",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,64.6666667 C70,65.4026667 69.469037,66 68.8148148,66 L55.1851852,66 C54.5297778,66 54,65.4026667 54,64.6666667 L54,62 L70,62 L70,64.6666667 Z",
    id: "Fill-80",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,64.6666667 C70,65.4026667 69.469037,66 68.8148148,66 L55.1851852,66 C54.5297778,66 54,65.4026667 54,64.6666667 L54,62 L70,62 L70,64.6666667 Z",
    id: "Stroke-81",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,62 L60,66 L69.7777778,66 C70.4524444,66 71,65.4026667 71,64.6666667 L71,62 L63.6666667,62 Z",
    id: "Fill-82",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6666667,62 L60,66 L69.7777778,66 C70.4524444,66 71,65.4026667 71,64.6666667 L71,62 L63.6666667,62 Z",
    id: "Stroke-83",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-84",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "52 37 73 37 73 35 52 35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-85",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "52 37 73 37 73 35 52 35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,82 L52,82 L52,35.2 C52,34.5376 51.553,34 51,34 C50.448,34 50,34.5376 50,35.2 L50,82 Z",
    id: "Fill-86",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,82 L52,82 L52,35.2 C52,34.5376 51.553,34 51,34 C50.448,34 50,34.5376 50,35.2 L50,82 Z",
    id: "Stroke-87",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,82 L75,82 L75,35.2 C75,34.5376 74.552,34 74,34 C73.447,34 73,34.5376 73,35.2 L73,82 Z",
    id: "Fill-88",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,82 L75,82 L75,35.2 C75,34.5376 74.552,34 74,34 C73.447,34 73,34.5376 73,35.2 L73,82 Z",
    id: "Stroke-89",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,67 C56.889611,67 58.4210526,68.5281736 58.4210526,70.4137522 L58.4210526,94.9927677 C58.4210526,97.7582038 60.667643,100 63.4401831,100 L68,100",
    id: "Stroke-90",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4285714,101 L73,101 L73,98 L69.4285714,98 C68.6397516,98 68,98.6717391 68,99.5 C68,100.328261 68.6397516,101 69.4285714,101",
    id: "Fill-91",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4285714,101 L73,101 L73,98 L69.4285714,98 C68.6397516,98 68,98.6717391 68,99.5 C68,100.328261 68.6397516,101 69.4285714,101 Z",
    id: "Stroke-92",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,78 L69,85.7992391 C69,87.566413 70.4706905,89 72.2863427,89 L75.3529412,89 C78.4723274,89 81,91.4618478 81,94.5 C81,97.5369565 78.4723274,100 75.3529412,100 L72.5294118,100",
    id: "Stroke-93",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,78 L65,85.7023913 C65,87.5233696 66.4307246,89 68.1976812,89 L75,89",
    id: "Stroke-94",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,103 C24,104.104928 30.0433043,105 37.5,105 C44.9555217,105 51,104.104928 51,103 C51,101.895072 44.9555217,101 37.5,101 C30.0433043,101 24,101.895072 24,103",
    id: "Fill-95",
    fill: "#F4F6FC",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6923077,29 C30.1038127,29 26.3846154,32.6454037 26.3846154,37.1428571 L26.3846154,38.2297516 C25.6008027,38.3914286 25,39.0404969 25,39.8571429 C25,40.7339752 25.6874916,41.4314286 26.5591973,41.5199379 C27.341806,45.2196273 30.6853512,48 34.6923077,48 C39.2808027,48 43,44.3545963 43,39.8571429 L43,37.1428571 C43,32.6454037 39.2808027,29 34.6923077,29",
    id: "Fill-96",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6923077,29 C30.1038127,29 26.3846154,32.6454037 26.3846154,37.1428571 L26.3846154,38.2297516 C25.6008027,38.3914286 25,39.0404969 25,39.8571429 C25,40.7339752 25.6874916,41.4314286 26.5591973,41.5199379 C27.341806,45.2196273 30.6853512,48 34.6923077,48 C39.2808027,48 43,44.3545963 43,39.8571429 L43,37.1428571 C43,32.6454037 39.2808027,29 34.6923077,29 Z",
    id: "Stroke-97",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,63.8378378 C21,56.7473561 26.8199542,51 34,51 C41.1788558,51 47,56.7473561 47,63.8378378 L47,65.8648649 L43.5789474,65.8648649 L43.5753776,76 L25.7894737,76 L25.784714,65.8648649 L21,65.8648649 L21,63.8378378 Z",
    id: "Fill-98",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,63.8378378 C21,56.7473561 26.8199542,51 34,51 C41.1788558,51 47,56.7473561 47,63.8378378 L47,65.8648649 L43.5789474,65.8648649 L43.5753776,76 L25.7894737,76 L25.784714,65.8648649 L21,65.8648649 L21,63.8378378 Z",
    id: "Stroke-99",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,38 C35,38.5522042 34.5524638,39 33.9994203,39 C33.4475362,39 33,38.5522042 33,38 C33,37.4477958 33.4475362,37 33.9994203,37 C34.5524638,37 35,37.4477958 35,38",
    id: "Fill-100",
    fill: "#7450C8",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,38 C38,38.5522042 38.4475362,39 38.9994203,39 C39.5524638,39 40,38.5522042 40,38 C40,37.4477958 39.5524638,37 38.9994203,37 C38.4475362,37 38,37.4477958 38,38",
    id: "Fill-101",
    fill: "#7450C8",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,40.9994203 C32,41.5524638 31.5524638,42 31.0005797,42 C30.4486957,42 30,41.5524638 30,40.9994203 C30,40.4475362 30.4486957,40 31.0005797,40 C31.5524638,40 32,40.4475362 32,40.9994203",
    id: "Fill-102",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,43 C35.2104348,43.696 36.7895652,43.696 38,43",
    id: "Stroke-103",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,35.1764706 C44,30.1088491 39.9701672,26 35,26 C30.0286288,26 26,30.1088491 26,35.1764706 L26,38 C28.4597993,37.3235806 29.9274916,35.7841432 30.8461538,33.7647059 C34.7242809,36.4274169 39.8461538,35.8823529 44,35.1764706",
    id: "Fill-104",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,35.1764706 C44,30.1088491 39.9701672,26 35,26 C30.0286288,26 26,30.1088491 26,35.1764706 L26,38 C28.4597993,37.3235806 29.9274916,35.7841432 30.8461538,33.7647059 C34.7242809,36.4274169 39.8461538,35.8823529 44,35.1764706 Z",
    id: "Stroke-105",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,32 C30,32 30.3869565,32.6469565 31,33",
    id: "Stroke-106",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,79.6672464 C21,80.9553623 22.1192547,82 23.4993789,82 C24.8807453,82 26,80.9553623 26,79.6672464 L26,66 L21,66 L21,79.6672464 Z",
    id: "Fill-107",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,79.6672464 C21,80.9553623 22.1192547,82 23.4993789,82 C24.8807453,82 26,80.9553623 26,79.6672464 L26,66 L21,66 L21,79.6672464 Z",
    id: "Stroke-108",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,66 L26,62",
    id: "Stroke-109",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,66 L44,62",
    id: "Stroke-110",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,51.2956522 L34.5678392,56 L38,51.6360248 C36.6896985,51.2248447 35.2939698,51 33.8454774,51 C32.8693467,51 31.9183417,51.1043478 31,51.2956522",
    id: "Fill-111",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,51.2956522 L34.5678392,56 L38,51.6360248 C36.6896985,51.2248447 35.2939698,51 33.8454774,51 C32.8693467,51 31.9183417,51.1043478 31,51.2956522 Z",
    id: "Stroke-112",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,55.5279252 L37.6185716,55.9829089 C38.4258097,56.1221107 39.1228573,55.3900123 38.9817145,54.5509348 L38.3824764,51 L35,55.5279252 Z",
    id: "Fill-113",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,55.5279252 L37.6185716,55.9829089 C38.4258097,56.1221107 39.1228573,55.3900123 38.9817145,54.5509348 L38.3824764,51 L35,55.5279252 Z",
    id: "Stroke-114",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5350795,51 L31.0116813,54.6894466 C30.9018774,55.4585821 31.5826611,56.1123472 32.3610482,55.9837574 L35,55.5511187 L31.5350795,51 Z",
    id: "Fill-115",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5350795,51 L31.0116813,54.6894466 C30.9018774,55.4585821 31.5826611,56.1123472 32.3610482,55.9837574 L35,55.5511187 L31.5350795,51 Z",
    id: "Stroke-116",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,55 L35,76",
    id: "Stroke-117",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7901701,60 L40.2098299,60 C39.5420038,60 39,60.5194203 39,61.1594203 L39,68.8405797 C39,69.4805797 39.5420038,70 40.2098299,70 L53.7901701,70 C54.4579962,70 55,69.4805797 55,68.8405797 L55,61.1594203 C55,60.5194203 54.4579962,60 53.7901701,60",
    id: "Fill-118",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7901701,60 L40.2098299,60 C39.5420038,60 39,60.5194203 39,61.1594203 L39,68.8405797 C39,69.4805797 39.5420038,70 40.2098299,70 L53.7901701,70 C54.4579962,70 55,69.4805797 55,68.8405797 L55,61.1594203 C55,60.5194203 54.4579962,60 53.7901701,60 Z",
    id: "Stroke-119",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,66.5 C48,67.3282609 47.3282609,68 46.5,68 C45.6717391,68 45,67.3282609 45,66.5 C45,65.6717391 45.6717391,65 46.5,65 C47.3282609,65 48,65.6717391 48,66.5",
    id: "Fill-120",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,66.5 C48,67.3282609 47.3282609,68 46.5,68 C45.6717391,68 45,67.3282609 45,66.5 C45,65.6717391 45.6717391,65 46.5,65 C47.3282609,65 48,65.6717391 48,66.5 Z",
    id: "Stroke-121",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,63.575 L47.575,63",
    id: "Stroke-122",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6942814,73 L45.3057186,73 C44.5838226,73 44,72.4386087 44,71.7467826 L44,70.8483478 C44,70.3798261 44.394651,70 44.8828006,70 L48.1171994,70 C48.6042618,70 49,70.3798261 49,70.8483478 L49,71.7467826 C49,72.4386087 48.4161774,73 47.6942814,73",
    id: "Fill-123",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6942814,73 L45.3057186,73 C44.5838226,73 44,72.4386087 44,71.7467826 L44,70.8483478 C44,70.3798261 44.394651,70 44.8828006,70 L48.1171994,70 C48.6042618,70 49,70.3798261 49,70.8483478 L49,71.7467826 C49,72.4386087 48.4161774,73 47.6942814,73 Z",
    id: "Stroke-124",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3076923,96.9178541 C43.5436789,96.9178541 43.7748495,96.9378039 44,96.9753562 L44,76 L26,76 L26,96.9178541 L31.5384615,96.9178541 C31.8250167,96.9178541 32.1055518,96.9460184 32.3752508,97 L32.8460201,84.0960604 C32.8893645,82.9671417 33.8405351,82.0729254 35,82.0729254 C36.1594649,82.0729254 37.1106355,82.9671417 37.1539799,84.0960604 L37.7692308,96.9178541 L43.3076923,96.9178541 Z",
    id: "Fill-125",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3076923,96.9178541 C43.5436789,96.9178541 43.7748495,96.9378039 44,96.9753562 L44,76 L26,76 L26,96.9178541 L31.5384615,96.9178541 C31.8250167,96.9178541 32.1055518,96.9460184 32.3752508,97 L32.8460201,84.0960604 C32.8893645,82.9671417 33.8405351,82.0729254 35,82.0729254 C36.1594649,82.0729254 37.1106355,82.9671417 37.1539799,84.0960604 L37.7692308,96.9178541 L43.3076923,96.9178541 Z",
    id: "Stroke-126",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,101 C48,98.7913043 46.0807453,97 43.7142857,97 L38,97 L38,99.6666667 C38,100.402899 38.6397516,101 39.4285714,101 L48,101 Z",
    id: "Fill-127",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,101 C48,98.7913043 46.0807453,97 43.7142857,97 L38,97 L38,99.6666667 C38,100.402899 38.6397516,101 39.4285714,101 L48,101 Z",
    id: "Stroke-128",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,101 C36,98.7913043 34.0819876,97 31.7142857,97 L26,97 L26,99.6666667 C26,100.402899 26.6397516,101 27.4285714,101 L36,101 Z",
    id: "Fill-129",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,101 C36,98.7913043 34.0819876,97 31.7142857,97 L26,97 L26,99.6666667 C26,100.402899 26.6397516,101 27.4285714,101 L36,101 Z",
    id: "Stroke-130",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration2);
export default __webpack_public_path__ + "static/media/Illustration2.f0885eaebd031987534bd464ae054c1d.svg";
export { ForwardRef as ReactComponent };